const InvestmentPlanFD = {
  label: 'Recommended Investment Plans',
  sections: [
    {
      type: 'text',
      text:
        "<br><h5>Change your financial future - here's a plan for you :)</h5>",
    },
    {
      type: 'cards',
      cards: [
        {
          title: 'Long Term, Aggressive Growth',
          returns: '15.3',
          doubledIn: () => {
            return `
            Looking for growth by investing monthly for over 3-5 years?`;
          },
          link: '/save/plan/26',
          highlighted: true,
          planId: 26,
        },
      ],
    },
    {
      type: 'text',
      text: () => {
        return `<br/>
        <small class="light">
          In the next step, we will show you more information<br>about the funds in the plan and help you finish investing!
        </small>`;
      },
    },
  ],
};

export default InvestmentPlanFD;



// WEBPACK FOOTER //
// ./components/recommendation/cards/investmentPlanFD.ts